export default {
  title: 'Recibe novedades y ofertas por email',
  form: {
    marketing_subscription: {
      label: 'Recibe ofertas exclusivas, descuentos y novedades directamente en tu bandeja de entrada',
    },
  },
};
